import { atomWithStorage } from 'jotai/utils'

export type ColorMode = 'light' | 'dark'

/**
 * アプリのカラーモード（ライト / ダーク）。localStorage に永続化される。
 */
export const colorModeAtom = atomWithStorage<ColorMode>('canaly-color-mode', 'light')
